import React from 'react';
import styled from 'styled-components';
import {Form, Button, Input, InputNumber, Radio} from 'components/antd';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import {Step, useUpdateStepMutation} from 'api';
import useClientUser from 'hooks/useClientUser';

interface Props {
  step: Step;
}

export default ({step}: Props) => {
  const {isMember} = useClientUser();
  const [updateStep, {loading}] = useUpdateStepMutation();
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: step?.name || '',
      memo: step?.memo || '',
      scheduleType: step?.isImmediately ? 'isImmediately' : 'period',
      startDay: step?.startDay || 1,
      isImmediately: step?.isImmediately || false,
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required('必須項目です'),
    }),
    onSubmit: (values) => {
      if (values.scheduleType === 'isImmediately') {
        values.isImmediately = true;
        values.startDay = null;
      } else {
        values.isImmediately = false;
      }
      delete values.scheduleType;
      updateStep({variables: {uuid: step.uuid, attributes: values}});
    },
  });

  return (
    <Container>
      <Form layout="vertical" onFinish={formik.handleSubmit}>
        <Form.Item
          label="ステップ名"
          validateStatus={formik.errors.name && 'error'}
          help={formik.errors.name}>
          <Input {...formik.getFieldProps('name')} disabled={!isMember} />
        </Form.Item>
        <Form.Item label="実行タイミング">
          <Radio.Group
            {...formik.getFieldProps('scheduleType')}
            disabled={!isMember}>
            <Form.Item style={{marginBottom: '0.5rem'}}>
              <Radio value="period" />
              <InputNumber
                min={1}
                style={{width: '6rem', marginRight: '0.5rem'}}
                value={formik.values.startDay}
                onChange={(value) => formik.setFieldValue('startDay', value)}
                disabled={
                  formik.values.scheduleType === 'isImmediately' || !isMember
                }
              />
              日後に実行
            </Form.Item>
            <Form.Item style={{marginBottom: '0'}}>
              <Radio value="isImmediately" />
              即時送信
            </Form.Item>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="メモ">
          <Input.TextArea
            {...formik.getFieldProps('memo')}
            disabled={!isMember}
          />
        </Form.Item>
        <Actions>
          {isMember && (
            <Button
              type="primary"
              htmlType="submit"
              disabled={!formik.isValid || !formik.dirty}
              loading={loading}>
              保存
            </Button>
          )}
        </Actions>
      </Form>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;

  .ant-form-item-label label {
    font-weight: bold;
  }

  p {
    color: var(--text-color-2);
  }

  .ant-input-number {
    width: 46px !important;
    height: 35px !important;

    input {
      text-align: center;
    }
  }

  .ant-input-number-handler-wrap {
    display: none;
  }
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  column-gap: 0.5rem;
`;
